import { unescapeHtml } from 'utils/htmlSymbolHandling'

const DataBridgeUserParamsDefinitions = [
  {
    section: 'userDetails',
    tag: 'emailFrom',
    label: 'Email',
    type: 'text',
  },
  {
    section: 'userDetails',
    tag: 'emailReply',
    label: 'Reply To',
    type: 'text',
  },
  {
    section: 'userDetails',
    tag: 'surveyUnits',
    label: 'Depth Units',
    type: 'dropDownWithSearch',
    width: '100%',
  },
  {
    section: 'userDetails',
    tag: 'mudUnits',
    label: 'Mud Units',
    type: 'dropDownWithSearch',
    width: '100%',
  },
  {
    section: 'userDetails',
    tag: 'dateFormat',
    label: 'Date Format',
    type: 'dropDownWithSearch',
    width: '100%',
  },
  {
    section: 'allowedActions',
    tag: 'actions',
    label: 'Actions',
    type: 'custom',
  },
]

export function getDetails(formData, dropDownOptions, validation, renderers = {}) {
  const details = {
    userDetails: [],
    allowedActions: [],
  }

  if (!formData || typeof formData !== 'object') return details

  DataBridgeUserParamsDefinitions.forEach((field, index) => {
    const value = formData[field.tag] === undefined || formData[field.tag] === null ? '' : formData[field.tag]

    details[field.section].push({
      ...field,
      id: index,
      value,
      ...(field.type === 'dropDownWithSearch' && {
        dropDownOptions: (dropDownOptions[field.tag] ?? []).map((value) => unescapeHtml(value)),
      }),
      ...(field.tag === 'emailFrom' && {
        error: validation.showErrors && !validation.emailFromValid,
        helperText:
          validation.showErrors && !validation.emailFromValid ? 'A valid email is required' : '',
      }),
      ...(field.tag === 'emailReply' && {
        error: validation.showErrors && !validation.emailReplyValid,
        helperText:
          validation.showErrors && !validation.emailReplyValid ? 'Enter a valid email' : '',
      }),
      ...(field.type === 'custom' && {
        render: renderers[field.tag],
      }),
    })
  })

  return details
}

export default DataBridgeUserParamsDefinitions